import React from 'react';
import parentstyles from '../../index.module.css';
import { updateProcedure } from '../../../../api/profiles';

export default function ProcedureRow({ user, procedure, i, setProcedures, procedures, profileIsCurrentUser }) {
  const editVisibility = () => {
    updateProcedure(user.profile_id, procedure.id, { private: !procedure.private }, (data) => {
      setProcedures(data);
    });
  };

  const renderSurgeryOrProcedure = (cond) => {
    if (cond.surgery && cond.surgery !== "I'm not sure") {
      return cond.surgery;
    }

    return cond.procedure;
  };

  return (
    <div
      data-pendo-tag='profile page - health profile - procedure row'
      className={i !== 0 ? 'marg-top-15' : null}
      style={{ display: 'flex' }}
    >
      <p className={`${parentstyles.bio}`}>{renderSurgeryOrProcedure(procedure)}</p>
      {profileIsCurrentUser && (
        <div
          data-pendo-tag='profile page - health profile - edit procedure row'
          style={{ marginLeft: 'auto', cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center' }}
        >
          <img
            onClick={() => editVisibility(procedure.id)}
            src={
              procedure.private
                ? 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platform/eye-off.svg'
                : 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platform/eye.svg'
            }
          />
        </div>
      )}
    </div>
  );
}
